export default function getModules() {
  return {
    prebidScript: 'https://micro.rubiconproject.com/prebid/dynamic/15770.js',
    useLimitedAds: true,
    useLoadDMByAdsLib: true,
    usePlacementCheck: true,
    useStats: true,
    useCustomNO: true,
  };
}

export const getNOPathIdExceptions: PathIdExceptions = {
  'sol.no': 'sol',
};
